import { render, staticRenderFns } from "./app-aside.vue?vue&type=template&id=6f90556e&scoped=true"
import script from "./app-aside.vue?vue&type=script&lang=js"
export * from "./app-aside.vue?vue&type=script&lang=js"
import style0 from "./app-aside.vue?vue&type=style&index=0&id=6f90556e&prod&lang=scss&scoped=true"
import style1 from "./app-aside.vue?vue&type=style&index=1&id=6f90556e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f90556e",
  null
  
)

export default component.exports